import * as actionTypes from './constants'
import { currentBulkUpdateConversationStatus } from '../conversation/bulkUpdate/selectors';

const initialState = {
    integrationProperties: [],
    integrationMappings: [],
    integrationMappingsErr: null,
    integrationPatchLoading: false
}

const sortedByStatic = mappings => _.sortBy(mappings, mapping => !mapping.static)

const integrationMappings = function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_PARDOT_FIELDS_SUCCESS:
            return Object.assign({}, state, { integrationFields: action.fields })

        case actionTypes.FETCH_PARDOT_MAPPINGS_SUCCESS:
            const clonedState = Object.assign({}, state)
            clonedState.integrationMappings = sortedByStatic(action.mappings)
            return clonedState

        case actionTypes.PATCH_PARDOT_MAPPINGS_SUCCESS:
            return Object.assign({}, state, {
                integrationMappings: sortedByStatic(action.mappings),
                integrationMappingsErr: null,
                integrationPatchLoading: false
            })

        case actionTypes.PATCH_PARDOT_MAPPINGS_ERROR:
            return Object.assign({}, state, { integrationMappingsErr: action.err, integrationPatchLoading: false })

        case actionTypes.PATCH_PARDOT_MAPPINGS_START:
            return Object.assign({}, state, { integrationPatchLoading: true })

        default:
            return state
    }
}

export default integrationMappings


// WEBPACK FOOTER //
// ./src/scripts/app/modules/pardot/reducer.js